import {useSelector} from 'react-redux'
import {ContentHotel} from '@findhotel/sapi'
import {usePriceInsightsFAQ} from 'hooks/usePriceInsightsFAQ'
import {usePricePrediction} from 'hooks/usePricePrediction'
import {getIsNoDatesSearch} from 'modules/search/selectors'

import {Divider} from '@vio/atlas/src/components/designSystem/Divider'
import {Box} from '@vio/atlas/src/components/designSystem/helpers/Box'

import {ConditionalPriceInsightsFAQ} from './ConditionalPriceInsightsFAQ'
import {ConditionalPricePrediction} from './ConditionalPricePrediction'

export const ConditionalPriceInfoSection = ({
  hotel,
  variant
}: {
  hotel: ContentHotel
  variant: 'vertical' | 'horizontal'
}) => {
  const hotelId = hotel?.objectID
  const {faqs} = usePriceInsightsFAQ(hotelId)
  const {hasAvailablePrices} = usePricePrediction(hotelId)
  const isNoDatesSearch = useSelector(getIsNoDatesSearch)

  if (!faqs?.length && !hasAvailablePrices) return null

  return (
    <>
      <Box
        paddingBottom={
          isNoDatesSearch && variant === 'horizontal' ? 's900' : 's000'
        }
      >
        {variant === 'vertical' && (
          <Box paddingTop={'s700'} paddingBottom={'s700'}>
            {<Divider sideMargin={'s500'} />}
          </Box>
        )}
        <ConditionalPriceInsightsFAQ hotel={hotel} variant={variant} />
        <ConditionalPricePrediction hotelId={hotelId} variant={variant} />
        {variant === 'horizontal' && !isNoDatesSearch && (
          <Box marginTop="s900" marginBottom="s600">
            <Divider />
          </Box>
        )}
      </Box>
    </>
  )
}
